let cashManagement = {
    "pinned": [
    ],
    "width": {
      "Deal": 240,
      "ReceivedDate": 94,
      "WireDate": 94
    },
    "immutable": {
    },
    "mapping": {
      "Deal": {
        "header": "Deal",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Deal",
        "cellEditor": "agTextCellEditor"
      },
      "Type": {
        "header": "Type",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Type",
        "cellEditor": "agTextCellEditor"
      },
      "ReceivedDate": {
        "header": "Received Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "ReceivedDate"
      },
      "WireDate": {
        "header": "Wire Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "WireDate"
      },
      "FRBBalancedCKG": {
        "header": "FRB Balanced Checking",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FRBBalancedCKG",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "FRBCoInvestCKG": {
        "header": "FRB Co-Invest Checking",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FRBBalancedCKG",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "FRBTrancheIICKG": {
        "header": "FRB Tranche II Checking",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FRBBalancedCKG",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "FundName": {
        "header": "Fund Name",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FundName",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "Tranche": {
        "header": "Tranche",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Tranche",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "FundGroup": {
        "header": "Fund Group",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FundGroup",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      }
    }
  }
  export  { cashManagement }
  
